import React, { useState, useEffect } from 'react';
import '../css/Project.css';
import '../css/Collab.css';
import strykCover from '../assets/stryk-cover.webp';
import buxCover from '../assets/bux-cover.webp';
import wonderkindCover from '../assets/wonderkind-cover.webp';

import ButtonLarge from '../components/Button-large';
import '../css/Buttons.css';
import Project from '../components/Projects';
import ProjectStryk from './ProjectStryk';
import ProjectBuxZero from './ProjectBuxZero';
import ProjectWonderkind from './ProjectWonderkind';

import { Shape1, ShapeRectangle, Shape3 } from '../components/Shapes';
import {
  MdArrowForward,
  MdBuild,
  MdNavigation,
  MdPersonAddDisabled,
  MdChat,
  MdLocalCafe,
  MdViewQuilt,
  MdImageSearch,
  MdFlashOn,
  MdBakeryDining,
  MdTextFields,
  MdHandshake,
  MdShare,
} from 'react-icons/md';
import collabLogo from '../assets/collab-logos/logo-cc-amstel.svg';
import ProductCard from '../components/ProductCard';
import ContactForm from '../components/ContactForm';
import bananaBread from '../assets/banana-bread.webp';
import blueberryCookie from '../assets/blueberry-cookie.webp';
import chocolateChipCookie from '../assets/chocolate-chip-cookie.webp';
import basqueCheesecake from '../assets/basque-cheesecake.webp';
import paoDeQueijo from '../assets/pao-de-queijo.webp';
import cheeseScone from '../assets/cheese-scone.webp';
import emptyImage from '../assets/empty-image.webp';
import lemonPoppySeedLoaf from '../assets/lemon-poppy-loaf.webp';
import veganIcon from '../assets/vegan-icon.svg';
import glutenFreeIcon from '../assets/gluten-free-icon.svg';
import hazelnutCookie from '../assets/hazelnut-cookie.webp'
import chocolateBabka from '../assets/chocolate-babka.webp'
import cardamomBabka from '../assets/cardamom-babka.webp'
import ubeTiramisu from '../assets/ube-tiramisu.webp'

// If the image is not appearing, check that '../assets/banana-bread.png' exists and is spelled correctly.
// If using create-react-app, only .png, .jpg, .jpeg, .gif, .webp, .svg are supported in imports.

const Home = ({}) => {
  useEffect(() => {
    const elements = document.querySelectorAll('.move-right, .move-left');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target); // animate once
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const [isProjectVisible, setIsProjectVisible] = useState(false);

  const handleButtonClick = () => {
    setIsProjectVisible(!isProjectVisible); // Toggle visibility
  };

  return (
    <div className="homepage">
      {/* Hero Section */}
     {/* Hero Section */}
     <header className="intro">
        <div className="shapes-container-inside blur-desktop blur-mobile">
          <ShapeRectangle className="shape shape-5" />
          <Shape3 className="shape shape-6" />
        </div>

        <div className="hero generic-hero">
        
          <h1>Baking small<br/> to serve it right</h1>
        </div>
      </header>

      <div className="shapes-container-outside">
        <Shape1 className="shape shape-1" />
        <ShapeRectangle className="shape shape-2" />
        <Shape3 className="shape shape-3" />
        <Shape1 className="shape shape-4" />
      </div>

      {/* End of Hero Section */}

      {/* End of Hero Section */}

      <section className="section-intro">
        <div className="challenges-content">
          <p>
We're an Amsterdam-based micro-bakery crafting fresh, handcrafted pastries and baked goods using locally sourced ingredients whenever possible and careful, small-batch techniques. With a focus on quality and creativity, our goal is to deliver treats that are as memorable as they are delicious.

          </p>
        </div>
      </section>

     

      {/* Product offering Section */}
      <section className="case-studies">
        <div className="case-studies-grid">
          <div className="section-header">
            <h2>Product offering</h2>
          </div>

          <div className="cases">
           <ProductCard
              productImage={bananaBread}
              productTitle="Banana Bread"
              isVegan={true}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00 - €4.50"
              retailUnit="per slice"
              wholesalePrice="€26.00"
              wholesaleUnit="per loaf (30cm / 8-10 slices)"
              description="Moist, flavorful and vegan banana bread made with ripe bananas, candied walnuts and dark chocolate."
              extraInfo="Gluten free option available"
            />

            <ProductCard
              productImage={lemonPoppySeedLoaf}
              productTitle="Lemon Poppy Seed Loaf"
              isVegan={true}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00 - €4.50"
              retailUnit="per slice"
              wholesalePrice="€26.00"
              wholesaleUnit="per loaf (30 cm / 8-10 slices)"
              description="Moist, flavorful and vegan lemon poppy seed loaf covered in a sweet lemon glaze."
              extraInfo=""
            />

            <ProductCard
              productImage={basqueCheesecake}
              productTitle="Basque Burnt Cheesecake"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€6,50 - €7,50"
              retailUnit="per slice"
              wholesalePrice="€46.00"
              wholesaleUnit="per cake (24cm / 8-10 slices)"
              description="Soft, creamy cheesecake with a caramelized top and a rich, velvety texture."
              extraInfo=""
            />

          </div>


          <div className="cases">

            <ProductCard
              productImage={chocolateBabka}
              productTitle="Chocolate Babka"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4,50 - €5,50"
              retailUnit="per babka"
              wholesalePrice="€33,00"
              wholesaleUnit="per batch (12 frozen babkas)"
              description="Yeast-raised babka bun swirled with a rich dark chocolate filling."
              extraInfo=""
            />

            <ProductCard
              productImage={cardamomBabka}
              productTitle="Cardamom Babka"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4,50 - €5,50"
              retailUnit="per babka"
              wholesalePrice="€33,00"
              wholesaleUnit="per batch (12 frozen babkas)"
              description="Yeast-raised babka bun swirled with a delicious cardamom and cinnamon filling."
              extraInfo=""
            />

            <ProductCard
              productImage={chocolateChipCookie}
              productTitle="Chocolate Chip Cookies"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€3,00 - €4,00"
              retailUnit="per cookie"
              wholesalePrice="€18,50"
              wholesaleUnit="per batch (8 frozen cookies)"
              description="A perfect mix between crunchy and chewy, with a deep dark chocolate flavour."
              extraInfo="Gluten free and vegan options available"
            />

            
          </div>



          <div className="cases">
           <ProductCard
              productImage={ubeTiramisu}
              productTitle="Ube Tiramisu"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€6.00 - €7.00"
              retailUnit="per tub"
              wholesalePrice="€27.90"
              wholesaleUnit="per batch (6 tubs)"
              description="A creamy and sweet Ube Tiramisu made with a rich ube (purple yam) cream and coconut milk."
              extraInfo=""
            />

            <ProductCard
              productImage={cheeseScone}
              productTitle="Cheese scones with pesto"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.50 - €5.50"
              retailUnit="per scone"
              wholesalePrice="€68.00"
              wholesaleUnit="per batch (24 frozen scones)"
              description="The perfect savoury snack served with a delicious homemade pesto."
              extraInfo=""
            />

            <ProductCard
              productImage={emptyImage}
              productTitle="Sample text"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="A perfect mix between crunchy and chewy, with a deep dark chocolate flavour."
              extraInfo="Gluten free option available"
              hidden={true}
            />
          </div>

          
          
{/*
          <div className="cases">
           <ProductCard
              productImage={paoDeQueijo}
              productTitle="Brazilian Cheese Bread"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="Moist, flavorful and vegan lemon poppy seed loaf covered in a sweet lemon glaze."
              extraInfo=""
            />

            <ProductCard
              productImage={cheeseScone}
              productTitle="Cheese scones"
              isVegan={false}
              isGlutenFree={false}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per cookie"
              wholesalePrice="€24.00"
              wholesaleUnit="per batch (24 frozen cookies)"
              description="Cakey, buttery cookies with roasted macadamia nuts, white chocolate and blueberry swirl."
              extraInfo=""
            />

            <ProductCard
              productImage={emptyImage}
              productTitle="Sample text"
              isVegan={false}
              isGlutenFree={true}
              veganIcon={veganIcon}
              glutenFreeIcon={glutenFreeIcon}
              retailPrice="€4.00"
              retailUnit="per slice"
              wholesalePrice="€24.00"
              wholesaleUnit="per loaf (8-10 slices)"
              description="A perfect mix between crunchy and chewy, with a deep dark chocolate flavour."
              extraInfo="Gluten free option available"
              hidden={true}
            />
          </div>

           */}


          

            
        </div>
      </section>

      <section className="outro">
        <div className="hero-outro">
          <h1>Get in touch with us!</h1>
          <section className="section-intro">
        <div className="challenges-content">
          <p>
          If you're interested in collaborating, have any questions or want to taste our menu send us a message!
          </p>
          
        </div>
        <div className='contact-form-block'>
        <ContactForm/>
        </div>

        <div className="contact-extra">
        <span className='contact-email'>Send us an e-mail at <a href="mailto:contact@chunksbakes.com" className="contact-email">
          contact@chunksbakes.com
        </a></span>
        <span className="contact-email " style={{ paddingTop: "20px" }}>
          Or find us on instagram <a href="https://www.instagram.com/chunks.delicious.bakes/" className="contact-email instagram-handle" target="_blank" rel="noopener noreferrer">
          @chunks.delicious.bakes
        </a>
        
        </span>
      </div>
        
        </section>
        </div>
      </section>
    </div>
  );
};

export default Home;
